import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/store/use-theme';

export function ThemeToggle() {
  const { theme, toggleTheme, mounted } = useTheme();

  const isDark = theme === 'dark';

  if (!mounted) {
    return (
      <button
        type="button"
        className="relative flex h-7 w-7 items-center justify-center rounded-sm text-muted-foreground transition-all duration-300 hover:bg-muted/80 hover:text-foreground"
        disabled
        aria-label="Carregando seletor de tema"
      >
        <div className="h-5 w-5" />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="group relative flex h-7 w-7 items-center justify-center rounded-sm text-inherit opacity-70 transition-all duration-300 hover:opacity-100"
      aria-label="Alternar tema"
      title={isDark ? 'Mudar para modo claro' : 'Mudar para modo escuro'}
    >
      <div className="relative h-5 w-5">
        <Sun
          className={`absolute inset-0 h-5 w-5 transition-all duration-500 ${
            isDark ? 'scale-0 rotate-90 opacity-0' : 'scale-100 rotate-0 opacity-100'
          }`}
        />
        <Moon
          className={`absolute inset-0 h-5 w-5 transition-all duration-500 ${
            isDark ? 'scale-100 rotate-0 opacity-100' : 'scale-0 -rotate-90 opacity-0'
          }`}
        />
      </div>
    </button>
  );
}
